"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _color = _interopRequireDefault(require("color"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _colorStringToTheme = _interopRequireDefault(require("../../utils/colorStringToTheme"));

var FormField = _styledComponents["default"].input.withConfig({
  displayName: "TextField__FormField",
  componentId: "xodz4-0"
})(["", " ", " ", " &:hover{background-color:", ";border-bottom:1px solid ", "}&:focus{background-color:", ";border-bottom:", ";transition:0.15s;margin-bottom:1px;& + label{color:", ";transform:translateY(-50%) translateX(-15%) scale(0.75);}}&:disabled{opacity:0.6;cursor:not-allowed;&:hover{background-color:", ";border-bottom:1px solid ", ";}& + label{opacity:0.6;}}&:invalid{box-shadow:none;}padding:", ";border-radius:", ";caret-color:", ";font-family:", ";font-size:", "px;font-weight:400;color:", ";line-height:1.75;letter-spacing:0.009375em;border:", ";border-bottom:", ";background-color:", ";outline:0;margin-bottom:1px;& + label{color:", ";font-family:", ";left:16px;right:auto;top:18px;pointer-events:none;position:absolute;line-height:1.15rem;transition:0.15s;transform:translateY(-50%) translateX(-15%) scale(0.75);}&[value=\"\"]{& + label{transform:none;}&:focus{& + label{color:", ";transform:translateY(-50%) translateX(-15%) scale(0.75);}}}"], _styledSystem.width, _styledSystem.space, _styledSystem.height, function (_ref) {
  var theme = _ref.theme,
      bg = _ref.bg;

  if (bg) {
    return (0, _color["default"])((0, _colorStringToTheme["default"])(theme, bg)).darken(0.04).rgb().toString();
  }

  return theme.colors.dark[6];
}, function (_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error,
      noHighlight = _ref2.noHighlight,
      border = _ref2.border;

  if (border) {
    return border;
  }

  if (noHighlight) {
    return "none";
  }

  return error ? "1px solid " + theme.colors.error[0] : "1px solid " + theme.colors.dark[1];
}, function (_ref3) {
  var theme = _ref3.theme,
      bg = _ref3.bg;

  if (bg) {
    return (0, _color["default"])((0, _colorStringToTheme["default"])(theme, bg)).darken(0.07).rgb().toString();
  }

  return theme.colors.dark[5];
}, function (_ref4) {
  var theme = _ref4.theme,
      error = _ref4.error,
      noHighlight = _ref4.noHighlight,
      border = _ref4.border;

  if (border) {
    return border;
  }

  if (noHighlight) {
    return "none";
  }

  return error ? "2px solid " + theme.colors.error[0] : "2px solid " + theme.colors.primary[0];
}, function (_ref5) {
  var theme = _ref5.theme,
      error = _ref5.error,
      noHighlight = _ref5.noHighlight;

  if (noHighlight) {
    return theme.colors.dark[2];
  }

  return error ? theme.colors.error[0] : theme.colors.primary[1];
}, function (_ref6) {
  var theme = _ref6.theme,
      bg = _ref6.bg;

  if (bg) {
    return (0, _color["default"])((0, _colorStringToTheme["default"])(theme, bg)).darken(0.5).rgb().toString();
  }

  return theme.colors.dark[7];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[3];
}, function (_ref8) {
  var label = _ref8.label,
      padding = _ref8.padding,
      iconName = _ref8.iconName;

  if (padding) {
    return padding;
  }

  return label ? "20px 16px 6px " + (iconName ? 40 : 16) + "px" : "14px 20px 14px " + (iconName ? 40 : 14) + "px";
}, function (_ref9) {
  var borderRadius = _ref9.borderRadius;
  return borderRadius + "px" || "4px 4px 0 0";
}, function (_ref10) {
  var theme = _ref10.theme,
      error = _ref10.error;
  return error ? theme.colors.error[0] : theme.colors.primary[0];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.sansSerif;
}, function (_ref12) {
  var fontSize = _ref12.fontSize;
  return fontSize;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.dark[1];
}, function (_ref14) {
  var border = _ref14.border;
  return border || "none";
}, function (_ref15) {
  var theme = _ref15.theme,
      error = _ref15.error,
      noHighlight = _ref15.noHighlight,
      border = _ref15.border;

  if (border) {
    return border;
  }

  if (noHighlight) {
    return "none";
  }

  return error ? "1px solid " + theme.colors.error[0] : "1px solid " + theme.colors.dark[3];
}, function (_ref16) {
  var theme = _ref16.theme,
      bg = _ref16.bg;
  return bg ? (0, _colorStringToTheme["default"])(theme, bg) : theme.colors.dark[7];
}, function (_ref17) {
  var theme = _ref17.theme,
      error = _ref17.error;
  return error ? theme.colors.error[0] : theme.colors.dark[2];
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fonts.sansSerif;
}, function (_ref19) {
  var theme = _ref19.theme,
      error = _ref19.error,
      noHighlight = _ref19.noHighlight;

  if (noHighlight) {
    return theme.colors.dark[2];
  }

  return error ? theme.colors.error[0] : theme.colors.primary[0];
});

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TextField__Wrapper",
  componentId: "xodz4-1"
})(["position:relative;width:", ";"], function (_ref20) {
  var wrapperWidth = _ref20.wrapperWidth;
  return wrapperWidth;
});

var IconFlex = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "TextField__IconFlex",
  componentId: "xodz4-2"
})(["position:absolute;align-content:center;align-items:center;margin-left:10px;"]);

var TextField = function TextField(_ref21) {
  var label = _ref21.label,
      id = _ref21.id,
      error = _ref21.error,
      helperText = _ref21.helperText,
      wrapperWidth = _ref21.wrapperWidth,
      noLabel = _ref21.noLabel,
      _ref21$iconName = _ref21.iconName,
      iconName = _ref21$iconName === void 0 ? null : _ref21$iconName,
      _ref21$iconStyle = _ref21.iconStyle,
      iconStyle = _ref21$iconStyle === void 0 ? {} : _ref21$iconStyle,
      onChange = _ref21.onChange,
      _ref21$height = _ref21.height,
      height = _ref21$height === void 0 ? 56 : _ref21$height,
      _ref21$bg = _ref21.bg,
      bg = _ref21$bg === void 0 ? null : _ref21$bg,
      _ref21$fontSize = _ref21.fontSize,
      fontSize = _ref21$fontSize === void 0 ? 14 : _ref21$fontSize,
      _ref21$border = _ref21.border,
      border = _ref21$border === void 0 ? null : _ref21$border,
      _ref21$padding = _ref21.padding,
      padding = _ref21$padding === void 0 ? null : _ref21$padding,
      _ref21$noHighlight = _ref21.noHighlight,
      noHighlight = _ref21$noHighlight === void 0 ? null : _ref21$noHighlight,
      maxLength = _ref21.maxLength,
      _ref21$borderRadius = _ref21.borderRadius,
      borderRadius = _ref21$borderRadius === void 0 ? null : _ref21$borderRadius,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref21, ["label", "id", "error", "helperText", "wrapperWidth", "noLabel", "iconName", "iconStyle", "onChange", "height", "bg", "fontSize", "border", "padding", "noHighlight", "maxLength", "borderRadius"]);

  var _useState = (0, _react.useState)(0),
      length = _useState[0],
      setLength = _useState[1];

  var handleInput = function handleInput(e) {
    setLength(e.target.value.length);
    onChange(e);
  };

  return _react["default"].createElement(Wrapper, {
    wrapperWidth: wrapperWidth,
    height: height
  }, iconName && _react["default"].createElement(IconFlex, {
    height: height,
    width: "auto"
  }, _react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    name: iconName
  }, iconStyle))), _react["default"].createElement(FormField, (0, _extends2["default"])({
    id: id,
    height: height,
    borderRadius: borderRadius,
    noHighlight: noHighlight,
    error: error,
    bg: bg,
    iconName: iconName,
    label: label,
    fontSize: fontSize,
    border: border,
    padding: padding,
    maxLength: maxLength > 0 ? maxLength : undefined,
    onChange: handleInput
  }, props)), _react["default"].createElement("label", {
    htmlFor: id
  }, label), !noLabel && _react["default"].createElement(_Flex["default"], {
    width: "inherit",
    height: 19,
    justifyContent: "space-between"
  }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    pl: 3
  }, error || helperText), maxLength > 0 && _react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    pr: 3,
    width: "auto"
  }, length, "/", maxLength))));
};

TextField.propTypes = {
  label: _propTypes["default"].string,
  id: _propTypes["default"].string,
  error: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  noLabel: _propTypes["default"].bool,
  wrapperWidth: _propTypes["default"].string,
  maxLength: _propTypes["default"].number,
  onChange: _propTypes["default"].func
};
TextField.defaultProps = {
  label: "",
  error: "",
  helperText: "",
  wrapperWidth: "inherit",
  noLabel: false,
  maxLength: 0,
  id: "",
  onChange: function onChange() {
    return null;
  }
};
var _default = TextField;
exports["default"] = _default;